export default "__VITE_ASSET__lQUqpr$G__"